{
  "add": "hinzufügen",
  "add-barn-first-description": "Registrieren Sie zunächst Scheunen in Ihren Einstellungen. Danach können Sie hier die Anreise anmelden.",
  "add-cycle": "Durchgang zufügen",
  "add-day-old-chick-first-description": "Registrieren Sie zunächst eine Ankunft. Danach können Sie die Abreise hier anmelden.\n",
  "age": "Alter",
  "amount": "Menge",
  "app": {
    "cycles": "Durchgänge",
    "deliveries": "Lieferungen",
    "reports": "Berichte",
    "settings": "Einstellungen",
    "products": "Artikel",
    "farmer-insights": "Farmers Insights",
    "advices": "Empfehlungen",
    "feed-advice": "Futterplan",
    "reference-value-sheet": "Referenzwerttabelle",
    "standard-reference-value-sheet": "Standard Referenzwerttabelle",
    "reference-scheme": "Referenz-Fütterungsempfehlungen",
    "management": "Management",
    "performance": "Leistung",
    "within-cycle-performance": "digitale Stallkarte"
  },
  "farmer-insights": {
    "kpiGroups": {
      "TechnicalPerformance": "Technische Leistung",
      "FinancialPerformance": "Finanzielle Leistung",
      "ArrivalAndDeparture": "Ankunft und Ausstallung",
      "FeedConsumption": "Futterverbrauch",
      "WellBeing": "Tierwohl",
      "RevenueAndCost": "Ertrag und Kosten"
    },
    "description": "Beschreibung",
    "locations": "Standorte",
    "location": "Standort",
    "cycles": "Durchgänge",
    "barns": "Ställe",
    "detail-level": "Detailebene",
    "display-type": "Anzeigetyp",
    "kpis-name": "kpi Bezeichnung",
    "table": "Tabelle",
    "chart": "Diagramm",
    "kpi-selection": "kpi Auswahl",
    "aggregation": {
      "Sum": "Summe",
      "Average": "Durchschnitt",
      "Min": "Minimum",
      "Max": "Maximum"
    },
    "custom-footers": {
      "end-total": "Gesamtsumme",
      "same-period": "gleiche Periode",
      "last-weeks": "letzte Wochen",
      "customer-average-selected-period": "Durchschnittlicher vom Kunden ausgewählter Zeitraum (Herden:"
    },
    "no-data": {
      "title": "Bezeichnung",
      "description": "Beschreibung"
    },
    "no-benchmark": "kein Vergleich",
    "benchmark-title": "<Tenant>",
    "benchmark-selected-period": "Vergleich, ausgewählte Periode",
    "benchmark-last-weeks": "Vergleich, letzte Wochen",
    "norm": "Standard",
    "benchmark-settings": "Einstellung Vergleich",
    "settings": {
      "header": "Überschrift",
      "title": "Bezeichnung",
      "subtitle": "Untertitel",
      "selected-period-label": "<Tenant> Vergleich für ausgewählte Periode anzeigen",
      "last-weeks-label": "Zeig den <Tenant>-Benchmark der letzten 10 Wochen an",
      "customer-average-selected-period-label": "Durchschnittlicher vom Kunden ausgewählter Zeitraum Wiedergabe",
      "none": "Keine",
      "select-multiple-benchmark-label": "Sie können mehrere Benchmarks auswählen",
      "select-one-benchmark-label": "Sie können maximal einen Benchmark auswählen",
      "non-detailed-view-label": "Nicht detaillierte Ansichten",
      "detailed-view-label": "Detaillierte Ansichten"
    },
    "reset-filters": "Filter zurücksetzen",
    "to": "zu",
    "maxPrintWarning": {
      "title": "Bezeichnung",
      "message": "Nachricht"
    },
    "kpis": {
      "DayOldChicks": "Eintagsküken",
      "DayOldChicksPrice": "Preis Eintagsküken",
      "TotalDeparture": "Gesamtabgabemenge",
      "DepartureWeight": "Ausstallungsgewicht",
      "SlaughterWeight": "Schlachtgewicht",
      "Revenue": "Ertrag",
      "FeedBalance": "Futterverbrauch",
      "FeedBalancePrice": "Futterverbrauch Betrag",
      "LossPercentage": "Verlustquote",
      "ReplacementPercentage": "Ersatzrate",
      "FeedConversion": "Futterverwertung",
      "FeedConversion1500": "Futterverwertung 1500g",
      "AverageWeightInGram": "Durchschnittliches Gewicht in g",
      "WeightedAverageAgeInDays": "Durchschnittliches gewichtetes Alter",
      "WeightedAverageGrowthPerDay": "Wachs",
      "ProductionNumber": "Produktionsnummer",
      "DayOldChicksPerSquareMeter": "Eintagsküken pro m²",
      "FeedUsageInKgPerSquareMeter": "Futterverbrauch pro m²",
      "FeedConsumptionPricePer100Kg": "Futterverbrauch Betrag pro 100 kg",
      "PaidAmountPerKg": "Bezahlter Betrag pro kg",
      "NettoRevenue": "Nettoertrag",
      "NettoRevenuePerChick": "Futtergewinn Menge pro Küken",
      "NettoRevenuePerSquareMeterPerDay": "Futtergewinn Betrag pro m² pro Tag",
      "RejectionRate": "Anteil Verwurf",
      "PricePerDayOldChick": "Preis pro Eintagsküken",
      "FeedBalanceMixProduct": "Futterverbrauch Mischfutter",
      "FeedBalanceRawProduct": "Futterverbrauch Rohprodukten",
      "DeliveredKgPerSquareMeter": "abgelieferte Kg pro m²",
      "NettoRevenuePerSquareMeter": "Futtergewinnmenge pro m²",
      "FeedConsumptionPerDeliveredKg": "Futterkosten pro kg geliefert",
      "DayOldChicksWeight": "Gewicht Eintagsküken",
      "WeightedHeelDermatitis": "Schwere Fersendermatitis",
      "WeightedFootpadLesionNonePercentage": "Gewichtet VZL 0",
      "WeightedFootpadLesionModeratePercentage": "Gewichtet VZL 1",
      "WeightedFootpadLesionSeverePercentage": "Gewichtet VZL 2",
      "TotalLoss": "Aussteigermenge",
      "WeightedFootpadLesionScore": "Gewichteter VZL-Score",
      "FeedBalanceRawPrice": "Futterverbrauch Rohwarenpreis",
      "FeedBalanceMixPrice": "Futterverbrauch Mischfutter Preis",
      "PartialDeparture": "teilweise Verladung",
      "FullDeparture": "vollständige Verladung",
      "NettoProfitInclOtherCosts": "Nettogewinn inklusive sonstiger Kosten",
      "DayOldChicksPriceExclDiscounts": "Futterverbrauch Betrag ohne Rabatte",
      "RevenueExclDiscounts": "Gezahlter Betrag ohne Rabatte",
      "FeedBalancePriceExclDiscounts": "Futterverbrauch Betrag ohne Rabatte"
    },
    "data-view-types": {
      "PerLocation": "Pro Standort",
      "PerCycle": "pro Durchgang",
      "PerCycleBarn": "Pro Runde und Stall",
      "PerLocationBarn": "Pro Stall"
    },
    "customer-average-selected-period": "Durchschnittlicher vom Kunden ausgewählter Zeitraum ",
    "show-more": "Zeige mehr",
    "show-less": "Zeige weniger"
  },
  "within-cycle-performance": {
    "advice_and_reference-value-sheet": "Empfehlung und Referenzwerttabelle",
    "kpi": "kpi",
    "kpis": {
      "IndoorTemperature": "Temperatur innen",
      "IndoorHumidity": "Luftfeuchte innen",
      "MortalityPercentage": "Sterblichkeit",
      "FeedIntakePerChick": "Futteraufnahme pro Tier",
      "WaterIntakePerChick": "Wasseraufnahme pro Tier",
      "WeightGainPerChick": "Gewichtszunahme pro Tier",
      "WaterToFeedRatio": "Wasser zu Futter Verhältnis",
      "FeedConversionRate": "Futterverwertung",
      "LitterQuality": "Einstreuqualität",
      "LitterQualityCaked": "Einstreuqualität, verkrustet",
      "LitterQualityLoose": "Einstreuqualität, lose",
      "LitterQualityWet": "Einstreuqualität, naß",
      "BodyWeight": "Lebendgewicht",
      "GrowthPrediction": "Wachstumsprognose",
      "IndoorOutdoorTemperature": "Temperatur innen/außen",
      "IndoorOutdoorHumidity": "Luftfeuchtigkeit drinnen/draußen",
      "OutdoorTemperature": "Aussentemperatur",
      "OutdoorHumidity": "Luftfeuchte aussen"
    },
    "no-data": "Keine Datei verfügbar."
  },
  "area": "Fläche",
  "arrival-date": "Ankunftsdatum",
  "avined": "IKB-KIP",
  "balance": {
    "add-manual-delivery": "manuelle Lieferung hinzufügen",
    "balance-row": "Balance-Regel",
    "barn-distribution": {
      "available-in-this-cycle": "Verfügbar in diesem Durchgang",
      "change-flock-allocation": "Ändere Herdenzuweiseung",
      "currently": "Währung",
      "delivery-line-info": "Lieferlinie Informationen",
      "flock-allocation": "Herdenzuweiseung",
      "kg-per-chick": "Kg pro Tier",
      "of-which-remaining": "Davon übrig",
      "total-should-be": "Die Gesamtausschüttung soll betragen",
      "totally-delivered": "Gesamtanlieferung",
      "usage-in-kg": "Verbrauch (kg)\n",
      "usage-in-other-cycles": "Nutzung in anderem Durchgang",
      "usage-in-this-cycle": "Nutzung in diesem Durchgang",
      "total": "Gesamt",
      "totalRaw": "Insgesamt Einzelfutter",
      "totalCompound": "Insgesamt Mischfutter"
    },
    "consumption": "Verbrauch",
    "delivery-date": "Datum Anlieferung",
    "empty-day-old-chick-description": "Fügen Sie zuerst den Vorrat hinzu. Anschließend können Sie hier die Balance-Regeln hinzufügen.",
    "empty-day-old-chick-title": "Es gibt noch kein Anlieferung",
    "empty-description": "Klicken Sie auf „Neu berechnen“, um den Saldo anzuzeigen.",
    "empty-title": "Keine Balance Zeilen gefunden",
    "manual-add": "Manuell",
    "multiple-deliveries": "Mehrere Lieferungen",
    "price": "Preis",
    "product": "Produkt",
    "quantity": "Menge",
    "recalculate": "neu berechnen",
    "recalculate-warning": {
      "text": "Text",
      "title": "Bezeichnung"
    },
    "remainder": "Rest",
    "remainder-greater-than-quantity": "Rest größer als Menge",
    "remainder-less-than-zero": "Rest weniger als Null",
    "remainder-less-than-quantity": "Rest weniger als Menge",
    "remainder-greater-than-zero": "Rest größer als Null",
    "remainder-other-than-zero": "Rest nicht gleich Null",
    "remainder-NaN": "Der Rest ist keine gültige Zahl.",
    "pending-changes-warning": {
      "title": "Nicht gespeicherte Änderungen",
      "message": "Sie haben nicht gespeicherte Änderungen in ihren Futterlieferungen.",
      "confirmText": "Fortfahren ohne zu speichern",
      "cancelText": "Stornieren"
    },
    "save-confirm": {
      "title": "Bezeichnung",
      "text": "Text",
      "alert": "Alarm"
    },
    "edit-confirm": {
      "title": "Bezeichnung",
      "text": "Text",
      "alert": "Alarm"
    },
    "not-finalized": {
      "title": "Bezeichnung",
      "message": "Nachricht"
    },
    "save-and-finalize": "speichern und abschließen",
    "save": "speichern",
    "edit": "Bearbeiten",
    "edit-balance": "Saldo verändern",
    "delete-confirm": {
      "text": "Text",
      "title": "Bezeichnung"
    },
    "has-empty-barns": {
      "title": "Bezeichnung",
      "message": "Nachricht"
    },
    "barn-name": "Stall",
    "invoice-date": "Rechnungsdatum",
    "invoice-number": "Rechnungsnummer",
    "delivery-number": "Liefer-ID"
  },
  "balance-item": {
    "add-product": "Artikel hinzufügen",
    "error-product-selected": "Wähle ein Produkt",
    "no-products": "keine Artikel",
    "product": "Artikel"
  },
  "balance-item-delivery": {
    "amount": "Menge",
    "current-usage": "aktueller Verbrauch",
    "error-amount": "Geben Sie die Menge ein",
    "error-no-amount": "Geben Sie die Menge für mindestens 1 Stall an.",
    "remaining-of": "rest von"
  },
  "balance-item-manual": {
    "amount": "Menge",
    "delivery-date": "Datum Anlieferung",
    "error-amount": "Geben Sie die Menge ein",
    "error-delivery-date": "Geben Sie das Lieferdatum ein",
    "error-no-amount": "Geben Sie den Betrag für mindestens einen Stall ein.",
    "error-price": "Geben Sie den Nettopreis ein",
    "error-product-title": "Geben Sie die Produktbeschreibung ein",
    "error-supplier-name": "Geben Sie den Namen des Lieferanten ein",
    "error-vat": "Geben Sie den Mehrwertsteuersatz ein",
    "price": "Preis",
    "product-title": "Produktbeschreibung",
    "product-type-multiple": "Mischfutter",
    "supplier-name": "Lieferant",
    "vat": "Mwst"
  },
  "balance-summary": {
    "consumption-per-delivered-chick": "Futteraufnahme pro geliefertem Küken",
    "final-stock": "Endbestand",
    "initial-stock": "Anfangsbestand",
    "title": "Bezeichnung",
    "total": "Gesamtsumme",
    "delivery-stock": "Lieferung (kg)",
    "product": "Artikel"
  },
  "barn": "Stall",
  "barn-item": {
    "area": "Fläche",
    "error-name-duplicate": "Dieser Scheunenname wird bereits verwendet. Geben Sie einen eindeutigen Stallnamen ein",
    "error-name-required": "Geben Sie den Stallnamen ein",
    "error-surface-area": "Geben Sie die Fläche ein",
    "name": "Bezeichnung",
    "animal-group-barn-id": "Stall-ID der Tiergruppe",
    "not-mapped": "(Nicht zugeordnet)"
  },
  "birth-date": "Geburtstag",
  "breed": "Rasse",
  "cadaver": "Kadaver",
  "catching": "fangen",
  "certification": "Zertifizierung",
  "chick-price": "Kükenpreis",
  "chickens": "Tiere",
  "chicks-parents-age-in-weeks": "Alter Elterntiere in Wochen",
  "chicks-weight-in-grams": "Kükengewicht in Gramm",
  "close-round": "Durchgang abschließen",
  "concept": "Konzept",
  "costs": "Kosten",
  "costs-specification": "Kostenspezifikation",
  "couple": "Paar",
  "couple-number": "Nr",
  "couples": "Paare",
  "customer-id": "Kundennummer",
  "cycle": "Durchgang",
  "cycle-navigation": {
    "balance": "Futterlieferungen",
    "closure": "Abschluss",
    "day-old-chick": "Einstallung",
    "departure": "Ausstallung",
    "general": "Allgemein"
  },
  "cycle-number": "Durchgangsnummer",
  "enter-amounts": "Beträge eingeben",
  "n/a": "n/v",
  "cycle-overview": {
    "barn": "Stall",
    "consumption-empty": {
      "description": "Beschreibung",
      "title": "Bezeichnung"
    },
    "daily-performance-empty": {
      "description": "Beschreibung",
      "title": "Bezeichnung"
    },
    "cycle": "Durchgang",
    "delete-cycle": "Durchgang löschen",
    "edit-current-week": "akutelle Woche bearbeiten",
    "weekregistration-overview": "Übersicht wöchentliche Eintragung",
    "detailedOverview": "detaillierte Übersicht",
    "edit": "verändern",
    "edit-cycle": "Durchgang bearbeiten",
    "option-all-barn": "- alle Ställe -",
    "panel": {
      "add-day-old-chick": "Vorrat hinzufügen",
      "add-departure": "Ablieferung hinzufügen",
      "amount": "Menge",
      "balance-overview": "Saldo-Übersicht",
      "balance-title": "Saldo Name",
      "birthdate": "Geburtstag",
      "consumption": "Verbrauch",
      "consumption-per-chick": "Futterverbrauch pro Tier",
      "date": "Datum",
      "day-old-chick-overview": "Übersicht Eintagsküken",
      "day-old-chick-title": "Ankunft Küken",
      "day-old-chick-total": "Gesamter ankunft Küken",
      "departure-overview": "Übersicht Abgänge",
      "departure-title": "Küken entfernung",
      "departure-total": "Vollständige Küken Entfernung",
      "departuredate": "Ablieferdatum",
      "departureweight": "Ausstallungsgewicht",
      "price": "Preis",
      "price-ex-vat-per-chick": "Preis exkl. Mwst. pro Küken",
      "price-ex-vat": "Preis exkl. Mwst.",
      "product-title": "Produktname",
      "product-type-mixedproduct": "Mischfutter",
      "product-type-rawproduct": "Rohfutter",
      "revenue": "Ertrag",
      "slaughterweight": "Schlachtgewicht",
      "type": "Typ",
      "type-full": "Vollständiger Abfluss",
      "type-manual": "Manuell",
      "type-partial": "Teilweise Abfluss",
      "type-platform": "Plattform",
      "type-start": "Plattform",
      "total-consumption": "Gesamtverbrauch",
      "daily-performance-title": "Wöchentliche und tägliche Beobachtungsaufzeichnungen",
      "edit-current-week": "aktuelle Woche bearbeiten",
      "cycle-title": "Runde",
      "discount-title": "Rabatte",
      "discount-overview": "Rabattübersicht"
    },
    "placeholder": "- eine Auswahl treffen -",
    "start-new-cycle": "neuen Durchgang beginnen",
    "weekregistration-download": "Vorlage herunterladen",
    "weekregistration-upload": "Importieren",
    "weekregistration-select-file": "Wählen Sie eine Datei aus...",
    "weekregistration-upload-csv-title": "Wählen Sie eine CSV-Datei zum Importieren aus",
    "upload-csv-message": "Spalten dürfen nicht aus der Vorlage entfernt werden, auch wenn sie leer sind. Felder können leer bleiben.",
    "upload-csv-notification": "Wählen Sie eine CSV-Datei zum Importieren aus",
    "weekregistration-select-interval-type": "Intervalltyp",
    "download-weekly-report": "Wochenbericht herunterladen",
    "cycle-start-in-future-warning-description": "Das Startdatum dieses Zyklus liegt in der Zukunft. Aus diesem Grund ist es nicht möglich, Beobachtungen zu registrieren.",
    "cycle-start-in-future-warning-title": "Der Zyklus hat noch nicht begonnen"
  },
  "wdo-labels": {
    "mortality": "Sterblichkeit",
    "feedIntake": "Futteraufnahme",
    "waterIntake": "Wasseraufnahme",
    "indoorTemperature": "Innentemperatur",
    "outdoorTemperature": "Aussentemperatur",
    "indoorHumidity": "Luftfeuchte innen",
    "outdoorHumidity": "Luftfeuchte aussen",
    "weight": "Gewicht",
    "litterQuality": "Einstreuqualität",
    "litterQualities": {
      "Loose": "Einstreu lose (%)",
      "Caked": "Einstreu verkrustet (%)",
      "Wet": "Einstreu nass (%)"
    },
    "selection": "Selektion",
    "selectionSmall": "Selektion Kümmerer",
    "selectionLegProblems": "Selektion Beinprobleme",
    "feedIntakeGramPerBird": "Futteraufnahme in g pro Tier",
    "feedIntakeKg": "Futteraufnahme in kg",
    "waterIntakeMililiterPerBird": "Wasseraufnahme in ml/Tier",
    "waterIntakeL": "Wasseraufnahme in l",
    "kilogramSuffix": "Kg",
    "gramSuffix": "Gramm",
    "literSuffix": "L",
    "mililiterSuffix": "Ml",
    "ageInDays": "Alter in Tagen"
  },
  "wdo-settings": {
    "title": "Bezeichnung",
    "disabled-message": "Diese Einstellungen können nicht mehr geändert werden, da mittlerweile wöchentliche Anmeldungen eingetragen sind.",
    "startday-description": "Hier legen Sie den Wochentag fest, an dem die erste Anmeldewoche beginnt.",
    "startday-label": "Wochentagseinstellung",
    "startday-placeholder": "- Wählen Sie einen Starttag aus -\n",
    "weekly-daily-description": "Hier legen Sie fest, welche Daten Sie pro Tag oder pro Woche eingeben möchten.",
    "open-settings": "Einstellungen öffnen",
    "general-option": {
      "label": "Allgemeine Einstellung",
      "per-day": "pro Tag",
      "per-week": "pro Woche"
    },
    "setting-option": {
      "off": "aus",
      "per-day": "pro Tag",
      "per-week": "pro Woche"
    },
    "delete-confirm": {
      "title": "Bezeichnung",
      "text": "Text"
    }
  },
  "wdo-registration": {
    "all-settings-are-off-title": "Alle Registrierungsfelder sind deaktiviert.",
    "all-settings-are-off-message": "Gehen Sie zuehrst auf der Registerkarte „Allgemein“ der Runde auf die Einstellungen „Wöchentliche und tägliche Beobachtung“ und geben Sie dort Ihre gewünschten Einstellungen ein.",
    "registration": "Eintragung",
    "cycle-date": "Liefertermin",
    "cycle-end-date": "Enddatum Durchgang",
    "select-week": "Woche auswählen",
    "select-week-placeholder": "- Woche auswählen -",
    "select-barn": "Stall auswählen",
    "select-barn-placeholder": "- Stall auswählen -",
    "validation-errors": {
      "total-must-be-100": "Gesamtsumme muss 100 ergeben",
      "date-is-not-valid-title": "Falsche Daten in der Upload-Datei",
      "date-is-not-valid-description": "In der Upload-Datei sind Daten vorhanden, deren Tag/Woche größer/kleiner als das Enddatum/Startdatum des Zyklus ist. Die Daten mit dem korrekten Datum bleiben erhalten."
    },
    "next-day": "nächster Tag"
  },
  "wdo-registration-overview": {
    "title": "Bezeichnung",
    "weekly-registrations": "wöchentliche Eintragung",
    "daily-registrations": "tägliche Eintragungen",
    "columns": {
      "weeknr": "Wochennummer",
      "date": "Datum"
    },
    "no-observations-found": {
      "title": "Bezeichnung",
      "message": "Nachricht"
    }
  },
  "chicks": "Tiere",
  "cycles": "Durchgänge",
  "dashboard": "Übersicht",
  "date": "Datum",
  "date-of-arrival": "Tag der Ankunft",
  "day-old-chicks": "Eintagsküken",
  "days": "Tage",
  "decontamination": "Dekontamination",
  "delete": "löschen",
  "delete-item-balance": "Möchten Sie die Saldozeile löschen?",
  "delete-item-barn-item": "Möchten Sie den Stall entfernen?",
  "delete-item-day-old-chick": "Möchten Sie die Lieferung löschen?",
  "delete-item-departure": "\nMöchten Sie die Abfahrt löschen?",
  "delete-item-flock-cycle": "\nMöchten Sie die Runde löschen?",
  "delivery": {
    "deliveries": "Lieferungen",
    "delivery": "Anlieferung"
  },
  "delivery-item": {
    "amount": "Menge",
    "delivery-date": "Lieferdatum",
    "error-amount": "Geben Sie die Menge ein",
    "error-delivery-date": "Geben Sie das Lieferdatum ein",
    "error-no-amount": "Geben Sie die Menge für mindestens 1 Stall an.",
    "error-price": "Geben Sie den Nettopreis ein",
    "error-product-title": "Geben Sie die Produktbeschreibung ein",
    "error-supplier-name": "Geben Sie den Namen des Lieferanten ein",
    "error-units-delivered": "Geben Sie gelieferte Einheiten ein",
    "error-units-delivered-not-enough": "Ein Teil dieses Vorrats wurde bereits in einer oder mehreren Runden verbraucht. Das Minimum beträgt daher:",
    "error-vat": "Geben Sie den Mehrwertsteuersatz ein",
    "external-product-id": "externe Artikelnummer",
    "manual-delivery": "manuelle Anlieferung",
    "price": "Preis",
    "product-title": "Produktbeschreibung",
    "product-type-multiple": "Mischfutter",
    "supplier-name": "Lieferant",
    "units-delivered": "Gelieferte Einheiten",
    "vat": "Mwst",
    "price-per-100kg": "Preis pro 100kg",
    "error-price-per-100kg": "Geben Sie den Nettopreis pro 100 kg ein",
    "barn": "Stall",
    "invoice-date": "Rechnungsdatum",
    "invoice-number": "Rechnungsnummer",
    "vat-percentage": "Mehrwertsteuer-Prozentsatz"
  },
  "delivery-overview": {
    "active": "aktiv",
    "delivery": "Anlieferung",
    "delivery-lines": "Lieferregeln",
    "display-in-cycle": "In Runde anzeigen",
    "no-deactivation": {
      "description": "Beschreibung",
      "title": "Bezeichnung"
    },
    "no-deliveries": {
      "description": "Beschreibung",
      "title": "Bezeichnung"
    },
    "remaining-of": "Rest von",
    "remove-delivery-warning": {
      "text": "Text",
      "title": "Bezeichnung"
    },
    "table": {
      "deliveryDate": "Lieferdatum",
      "deliveryId": "Liefer-ID",
      "product": "Artikel",
      "isActive": "Aktiv",
      "showInFinalSetup": "Im Endgültige Einrichtung anzeigen",
      "invoiceDate": "Rechnungsdatum",
      "invoiceNumber": "Rechnungsnummer"
    }
  },
  "departure": {
    "barn": "Stall",
    "empty-day-old-chicks-description": "Fügen Sie einen Vorrat hinzu und dieser wird hier angezeigt.",
    "empty-day-old-chicks-title": "Es gibt noch kein Vorrat",
    "empty-description": "Fügen Sie einen Abfluss hinzu und es wird hier angezeigt.",
    "empty-title": "Es gibt noch keine Abgänge"
  },
  "departure-date": "Ausstellungsdatum",
  "departure-item": {
    "age": "Alter",
    "amount-of-chicks": "Anzahl Tiere",
    "average-weight": "Durchschnittliches Gewicht",
    "barn": "Stall",
    "chicks": "Küken",
    "date": "Datum",
    "error-amount-of-chicks-max": "Die maximale Anzahl an Hühnern, die entfernt werden können, beträgt:",
    "error-amount-of-chicks-min": "Geben Sie mindestens 1 Huhn ein",
    "error-amount-of-chicks-required": "Geben Sie die Anzahl der Hühner ein",
    "error-barn": "Wählen Sie einen Stall",
    "error-date": "Geben Sie das Entsorgungsdatum ein. Dies muss nach dem frühesten Liefertermin liegen, jedoch nicht in der Zukunft.",
    "error-no-chicks-remaining": "Es sind keine Küken mehr zur Abreise übrig",
    "error-type": "Geben Sie die Art der Abfahrt ein",
    "footpad-lesion-score": "Fußballenläsionen Bewertung",
    "footpad-lesion-none": "Fußballenläsionen null",
    "footpad-lesion-moderate": "Fußballenläsionen moderat",
    "footpad-lesion-severe": "Fußballenläsionen schwer",
    "footpad-lesion-validation": "Fußballenläsionen Validierung",
    "heel-dermatitis": "Fersendermatitis",
    "revenue": "Gesamtumsatz (exkl. MwSt.)",
    "slaughter-results": "Schlachtergebnis",
    "slaughter-weight": "Schlachtgewicht",
    "rejection-at-slaughterhouse": "Verwurf im Schlachthof",
    "rejection-during-transport": "Verwurf beim Transport",
    "slaughterhouse": "Schlachthof",
    "type": "Type",
    "type-full": "Vollständige Ausstallung",
    "type-partial": "Teilweise Ausstallung",
    "weight": "Gewicht",
    "weight-validation": "Das bezahlte Gesamtgewicht darf das Gesamtgewicht der Lieferung nicht überschreiten.",
    "diverseCosts": "Vielfältige Kosten",
    "revenueSubTotal": "Ertrag"
  },
  "departure-title": "Entsorgung",
  "departure-type-full": "Vollständig",
  "departure-type-partial": "Teilweise",
  "download-pdf": "pdf herunterladen",
  "edit": "ändern",
  "electricity": "Elektrizität",
  "error-amount-of-chickens": "Geben Sie die Anzahl der Hühner ein",
  "error-amount-of-chicks": "Geben Sie die Anzahl der Eintagsküken ein\n",
  "error-amount-of-chicks-too-big": "Die Zahl der Eintagsküken ist zu groß",
  "error-arrival-date": "Geben Sie das Ankunftsdatum ein",
  "error-barn-selected": "Wählen Sie einen Stall",
  "error-breed": "Wählen Sie die Rasse",
  "error-chick-birth-date": "Geben Sie das Geburtsdatum ein",
  "error-chick-price": "Geben Sie den Preis pro Eintagsküken ein",
  "error-concept": "Wählen Sie das Konzept",
  "error-cycle-number": "Geben Sie eine eindeutige Rundennummer ein",
  "error-hatchery": "Wählen Sie die Brüterei",
  "error-start-date": "Geben Sie das Startdatum ein",
  "error-surface-area": "Geben Sie die Fläche ein",
  "error-total-costs": "Geben Sie die Gesamtkosten ein",
  "error-total-price": "Geben Sie den Betrag ein",
  "feed": "Futter",
  "flocks": "Herden",
  "general": "Allgemein",
  "grams": "Gramm",
  "hatchery": "Brüterei",
  "healthcare": "Gesundheitspflege",
  "heating": "heizen",
  "litter": "Einstreu",
  "management": "Management",
  "manure": "Mist",
  "no-barns-description": "Fügen Sie einen Stall hinzu und er wird hier angezeigt.",
  "no-barns-title": "Es wurden noch keine Ställe hinzugefügt",
  "no-cycle-selected-description": "Wählen Sie eine Runde aus, um deren Informationen anzuzeigen.",
  "no-cycle-selected-title": "Es wurde keine Runde ausgewählt",
  "no-cycles-description": "Fügen Sie eine Runde hinzu und sie wird hier angezeigt.",
  "no-cycles-title": "Es gibt noch keine Runden",
  "no-day-old-chicks-description": "Voeg aanvoer toe en deze zal hier worden getoond.",
  "no-day-old-chicks-title": "Es gibt noch kein Angebot",
  "no-departures-description": "Fügen Sie einen Abfluss hinzu und es wird hier angezeigt.",
  "no-departures-title": "Es gibt noch keinen Abfluss",
  "none": "Keiner",
  "nr": "Nr",
  "number-of-day-old-chicks": "Anzahl Eintagsküken",
  "other": "Andere",
  "print": "drucken",
  "remove-cycle": "Durchgang entfernen",
  "report-navigation": {
    "barn-report": "Stallbericht"
  },
  "report-overview": {
    "barn": "Stall",
    "barn-report": "Stallreport",
    "barn-report-loading": "wird generiert...",
    "cycle": "Durchgang",
    "reports": "Berichte",
    "cycle-closed": "Durchgang abgeschlossen"
  },
  "save-as-concept": "Als Konzept speichern",
  "settings": "Einstellungen",
  "settings-navigation": {
    "barns": "Ställe",
    "observationsetting": "Beobachtungen",
    "rvssetting": "Referenzwerteblätter",
    "farmresultsetting": "FarmResult",
    "performance": "Leistung",
    "finalsetupsetting": "Endgültige Einrichtung",
    "discountsetting": "Rabatte",
    "sustainabilitysetting": "Nachhaltigkeit"
  },
  "observations-setting": {
    "description": "Beschreibung",
    "switch": "wechseln"
  },
  "column-setting": {
    "title": "Bezeichnung",
    "description": "Beschreibung"
  },
  "rvs-setting": {
    "title": "Bezeichnung",
    "temperatureInside-option": {
      "label": "Temperatur",
      "Celcius": "Celsius",
      "Fahrenheit": "Fahrenheit",
      "short": {
        "Celcius": "(°C)",
        "Fahrenheit": "(F)"
      }
    },
    "feedIntake-option": {
      "label": "Fütter",
      "Gram": "Gramm",
      "Kilogram": "Kilogramm",
      "short": {
        "Gram": "(g)",
        "Kilogram": "(kg)"
      }
    },
    "waterIntake-option": {
      "label": "Wasser",
      "ML": "ml",
      "DL": "Deziliter",
      "L": "Liter",
      "short": {
        "ML": "(ml)",
        "DL": "(dl)",
        "L": "(l)"
      }
    },
    "weight-option": {
      "label": "Gewicht",
      "Gram": "Gramm",
      "Kilogram": "Kilogramm",
      "short": {
        "Gram": "(g)",
        "Kilogram": "(kg)"
      }
    },
    "dayoffset": {
      "title": "Bezeichnung",
      "label": "Starttag"
    }
  },
  "specify-costs": "Kosten angeben",
  "start-date": "Startdatum",
  "title": "Bezeichnung",
  "title_Agrifirm": "PoultryNEXT",
  "title_Agravis": "Avidata broiler",
  "total-costs": "Gesamtkosten",
  "total-price": "Gesamtpreis",
  "unspecified-costs": "unspezifische Kosten",
  "water": "Wasser",
  "water-additives": "Wasserzusätze",
  "weeks": "Wochen",
  "search": "suchen",
  "dateFrom": "Datum ab",
  "dateTo": "Datum bis",
  "days-of-week": {
    "Monday": "Montag",
    "Tuesday": "Dienstag",
    "Wednesday": "Mittwoch",
    "Thursday": "Donnerstag",
    "Friday": "Freitag",
    "Saturday": "Samstag",
    "Sunday": "Sonntag"
  },
  "unitOfMeasure": {
    "g/day": "g/Tag",
    "€/m²/day": "€/m²/Tag",
    "$/m²/day": "$/m²/Tag",
    "£/m²/day": "£/m²/Tag",
    "zł/m²/day": "zł/m²/Tag",
    "Ft/m²/day": "Ft/m²/Tag"
  },
  "feed-advice": {
    "overview": {
      "title": "Bezeichnung",
      "empty": {
        "title": "Bezeichnung",
        "description": "Beschreibung"
      },
      "table-header": {
        "name": "Bezeichnung",
        "created": "Erstellt",
        "updated": "aktualisiert",
        "updatedAdvisorName": "Aktualisiert von",
        "isActive": "Aktiv"
      },
      "buttons": {
        "add": "hinzufügen",
        "edit": "ändern",
        "delete": "löschen"
      }
    },
    "create-from-reference": {
      "title": "Bezeichnung",
      "scratch-title": "Starten Sie eine neue Fütterungsempfehlung",
      "scratch-option-title": "Starten Sie ein Fütterungsempfehlung",
      "scratch-button": "Beginnen Sie mit einem leeren Ratschlag",
      "scratch-option-subtitle": "Dies ist ein leerer Fütterungsempfehlung",
      "reference-schemes-title": "Wählen Sie als Grundlage eine Standard-Fütterungsempfehlung",
      "reference-schemes-button": "Beginnen mit",
      "product": "Produkt\n",
      "products": "Artikel",
      "additive": "Zusatzstoff",
      "additives": "Zusatzstoffe"
    },
    "dialog": {
      "deleteConfirm": "löschen bestätigen",
      "deleteConfirmWhenInUse": "\nDieser Fütterungshinweis ist mit einer Runde verknüpft. Sind Sie sicher, ob Sie diesen Fütterungshinweis löschen möchten?"
    },
    "create": {
      "print": "drucken",
      "title": "Bezeichnung",
      "name": "Bezeichnung",
      "error-name": "Ein Name für die Futtermittelempfehlung ist erforderlich.",
      "description": "Beschreibung",
      "description-placeholder": "Beschreibung der Fütterungsempfehlung",
      "product-placeholder": "- Wähle ein Produkt -",
      "add-product": "Artikel hinzufügen",
      "table-header": {
        "productName": "Produkt",
        "chickenWeightInGrams": "Kükengewicht (g)",
        "ageFrom": "Alter von",
        "ageTo": "Alter bis",
        "totalFeed": "Futteraufnahme (g)",
        "coreFeed": "Kern (g)",
        "wheatFeed": "Futterweizen",
        "comment": "Kommentar",
        "age": "Alter",
        "coreFeedTons": "Kern (Tonne)",
        "wheatFeedTons": "Weizen (Tonnen)",
        "dosage": "Dosierung",
        "applicationMoment": "Altersantrag"
      },
      "created": "erstellt",
      "updated": "aktualisiert",
      "number-of-day-old-chicks": "Anzahl Eintagsküken",
      "validation-error": {
        "title": "Bezeichnung",
        "feedadvice-name": "Der Name der Fütterungsempfehlung ist erforderlich",
        "age-from": "Alter von",
        "chicken-weight": "Das Kükengewicht ist erforderlich",
        "product": "Artikel",
        "total-feed": "Die Futteraufnahme ist erforderlich",
        "age-to": "Alter bis",
        "age-min-max": "Alter, min-max"
      },
      "products": "Artikel",
      "additives": "Zusatzstoffe",
      "show-additives": "Ergänzungen anzeigen",
      "add-additive": "Zusatzstoff hinzufügen"
    },
    "print": {
      "farmcompany": "Betrieb",
      "customernr": "Kundennummer",
      "contactperson": "Kontaktperson",
      "location": "Standort",
      "customerservice": "Kundenservice",
      "table-header": {
        "productName": "Produkt\n",
        "chickenWeightInGrams": "Tiergewicht in Gramm",
        "age": "Alter",
        "totalFeed": "Futteraufnahme",
        "coreFeed": "Kern",
        "wheatFeed": "Futterweizen",
        "comment": "Kommentar",
        "gramPerChick": "Gramm pro Tier",
        "orderQuantity": "Bestellmenge",
        "units_gram": "(g)",
        "units_days": "(Tage)",
        "dosage": "Dosierung",
        "units_kgton": "kg/Tonne",
        "applicationMoment": "Altersantrag"
      }
    }
  },
  "standard-reference-value-sheet": {
    "overview": {
      "title": "Bezeichnung"
    },
    "create": {
      "title": "Bezeichnung"
    }
  },
  "reference-value-sheet": {
    "overview": {
      "title": "Bezeichnung",
      "empty": {
        "title": "Bezeichnung",
        "description": "Beschreibung"
      },
      "table-header": {
        "name": "Bezeichnung",
        "created": "erstellt",
        "updated": "aktualisiert",
        "updatedAdvisorName": "Angepasst von",
        "isActive": "Aktiv"
      },
      "buttons": {
        "add": "hinzufügen",
        "edit": "Bearbeiten",
        "delete": "löschen",
        "copy-as-new": "Als neu kopieren",
        "copy-to-other-country": "In anderes Land kopieren"
      },
      "country": "Land"
    },
    "dialog": {
      "deleteConfirm": "Sind Sie sicher, dass Sie diese Standardkarte löschen möchten?",
      "deleteConfirmWhenInUse": "Diese Standardkarte ist mit einer Runde verknüpft. Sind Sie sicher, dass Sie diese Standardkarte löschen möchten?"
    },
    "create-from-standard": {
      "title": "Bezeichnung",
      "scratch-title": "Starten Sie eine neue Standardkarte",
      "scratch-option-title": "Starten Sie eine Standardkarte",
      "scratch-button": "Starten Sie eine neue Standardkarte",
      "scratch-option-subtitle": "Diese Standardkarte ist leer",
      "reference-value-sheet-title": "Wählen Sie als Basis eine Standard-Standardkarte",
      "reference-value-sheet-button": "Beginnen mit"
    },
    "create": {
      "print": "drucken",
      "title": "Bezeichnung",
      "name": "Bezeichnung",
      "error-name": "Es ist ein Standardkartenname erforderlich",
      "add-one-day-values-row": "Tag hinzufügen",
      "number-of-days": "Tagen",
      "add-multiple-day-values-rows": "Tagen hinzufügen",
      "description": "Beschreibung",
      "description-placeholder": "Standardkartenbeschreibung",
      "no-day-values-title": "Die Standardkarte ist noch leer",
      "no-day-values-description": "Fügen Sie der Standardkarte unten Tage hinzu, um loszulegen.",
      "table-header": {
        "day": "Tag",
        "temperatureInside": "Innentemp. ",
        "relativeHumidity": "relative Luftfeuchte (%)",
        "feedIntake": "Futteraufnahme ",
        "feedIntakePerChickPerDay": "Futteraufnahme pro Tier und Tag ",
        "feedIntakeTotal": "Futteraufnahme total ",
        "feedIntakePerChickTotal": "Futteraufnahme pro Tier kummuliert ",
        "waterIntake": "Wasser- aufnahme ",
        "weight": "Gewicht ",
        "mortality": "Sterblichkeit (%)",
        "feedConversion": "Futter- verwertung",
        "waterToFeedRatio": "Wasser:Futter Verhältnis"
      },
      "created": "erstellt",
      "updated": "aktualisiert",
      "validation-error": {
        "title": "Bezeichnung",
        "refvalsheet-name": "Es ist ein Standardkartenname erforderlich"
      }
    },
    "print": {
      "farmcompany": "Betrieb",
      "customernr": "Kundennummer",
      "contactperson": "Kontaktperson",
      "location": "Standort"
    },
    "select-country": {
      "title": "Bezeichnung",
      "description": "Beschreibung",
      "label": "Land"
    }
  },
  "reference-scheme": {
    "overview": {
      "title": "Bezeichnung",
      "empty": {
        "title": "Bezeichnung",
        "description": "Beschreibung"
      },
      "table-header": {
        "name": "Bezeichnung",
        "created": "erstellt",
        "updated": "aktualisiert",
        "updatedAdvisorName": "Angepasst von",
        "isActive": "Aktiv\n"
      },
      "buttons": {
        "add": "hinzufügen",
        "edit": "Bearbeiten",
        "delete": "löschen"
      },
      "country": "Land"
    },
    "dialog": {
      "deleteConfirm": "löschen bestätigen"
    },
    "create": {
      "title": "Bezeichnung",
      "name": "Bezeichnung",
      "error-name": "Der Name des standardmäßigen Fütterungshinweises ist erforderlich",
      "description": "Beschreibung",
      "description-placeholder": "Beschreibung der Standard-Fütterungsempfehlungen",
      "product-placeholder": "- Produkt auswählen -",
      "add-product": "Artikel hinzufügen",
      "table-header": {
        "productName": "Produkt",
        "chickenWeightInGrams": "Kükengewicht (g)",
        "ageFrom": "Alter von",
        "ageTo": "Alter bis",
        "totalFeed": "Futteraufnahme (g)",
        "coreFeed": "Kern (g)",
        "wheatFeed": "Futterweizen",
        "comment": "Kommentar"
      },
      "created": "erstellt",
      "updated": "aktualisiert"
    }
  },
  "product-title": "Produkten",
  "product-save": "Produkte speigern",
  "product-saved": "Produkt gespeichert!",
  "product-overview": {
    "title": "Bezeichnung",
    "overview": {
      "productName": "Name",
      "productCode": "Produktcode",
      "phase": "Fütterungsphasen",
      "isActive": "Aktiv",
      "productType-Feed": "Futter",
      "productType-Additive": "Zusatz",
      "productType": "Produkttyp"
    },
    "no-products": {
      "title": "Bezeichnung",
      "description": "Beschreibung"
    },
    "delete-confirmation-title": "Produkt entfernen",
    "delete-confirmation-message": "Sind Sie sicher, dass Sie dieses Produkt löschen möchten?",
    "delete-error-message": "Das Produkt konnte nicht entfernt werden. Stellen Sie sicher, dass es nicht in einem Referenzschema enthalten ist.",
    "delete-error-in-use-message": "Dieses Produkt kann nicht entfernt werden, da es in einer oder mehreren Fütterungsempfehlungen verwendet wird.",
    "country": "Land",
    "delete-confirmation-message-when-in-use": "Dieses Produkt wird in einer oder mehreren Fütterungsempfehlungen verwendet. Möchten Sie dieses Produkt wirklich entfernen?"
  },
  "create-product": {
    "title-create": "Produkt hinzufügen",
    "title-edit": "Produkt anpassen:",
    "product-name": "Artikelname",
    "phases-label": "Fütterungsphasen",
    "product-code": "Artikelnummer",
    "error-product-name": "Geben Sie den Namen des Produkts ein.",
    "error-product-code": "Geben Sie den Produktcode des Produkts ein.",
    "error-code-name-already-in-use": "Verwenden Sie eine eindeutige Kombination aus Name und Code",
    "product-type": {
      "label": "Produktart",
      "Feed": "Futter",
      "Additive": "Zusatzstoff"
    },
    "error-product-type": "Produkttyp ist erforderlich."
  },
  "countries": {
    "BE": "Belgien",
    "DE": "Deutschland",
    "HU": "Ungarn",
    "NL": "Niederlande",
    "PL": "Polen",
    "JO": "Jordanien",
    "NG": "Nigeria",
    "JM": "Jamaika",
    "TZ": "Tansania",
    "DA": "Deutschland-Agravis"
  },
  "save": "speichern",
  "report-title": "Übersicht über den Broilerstall",
  "report-name": "Herdenstallbericht-",
  "report-headers": {
    "general": "Algemein",
    "day-old-chicks": "Eintagsküken",
    "total": "Total",
    "departures": "Abgänge",
    "balance": "Saldo",
    "key-figures": "Schlüsselfiguren",
    "technical": "Technisch",
    "financial": "Finanziell"
  },
  "report-columns": {
    "customer": "Kunde",
    "location": "Standort",
    "barn": "Stall",
    "breed": "Rasse",
    "concept": "Konzept",
    "start-date": "Startdatum",
    "date": "Datum",
    "age": "Alter",
    "amount": "Menge",
    "price": "Preis",
    "discount": "Rabatt",
    "delivered": "abgeliefert",
    "weight": "Gewicht",
    "paid": "bezahlt",
    "rejected": "verworfen",
    "feed-code": "Artikelnummer",
    "feed-name": "Feedname",
    "consumption": "Verbrauch",
    "consumption-per-day-old-chick": "Futteraufnahme pro Eintagsküken",
    "day-old-chicks": "Eintagsküken",
    "drop-out-total": "Ausfall total (%)",
    "avg-age": "durchschnittliches Alter",
    "avg-weight": "Durchschnittsgewicht",
    "deliveredkg-per-m2": "abgelieferte Kg pro m²",
    "growth": "Wachstum",
    "feed-conversion": "Futterverwertung",
    "feed-conversion-1500": "Futterverwertung 1500g",
    "replacement": "Ersatz (%)",
    "avg-rejected": "Weitergegebene Ablehnung (%)",
    "production-number": "Produktionsnummer",
    "price-per-delivered-chick": "Preis pro ausgeliefertem Küken",
    "feed-price-per-100": "Futterpreis pro 100kg",
    "feed-price-per-delivered-kg": "Futterpreis pro geliefertem kg",
    "yield-per-kg": "Ertrag pro Kilogramm",
    "feed-profit": "Futterertrag",
    "feed-profit-per-day-old-chick": "Futtergewinnpaket (ct)",
    "feed-profit-per-m2-per-day": "Futtergewinn pro m² pro Tag (ct)",
    "cycle-nr": "Durchgangsnummer",
    "barns": "Ställe",
    "netto-profit-incl-other-costs": "Nettogewinn inklusive sonstiger Kosten",
    "discountLabel-ledenvoordeel": "Vorteile für Mitglieder",
    "discountLabel-ledenkorting": "Mitgliederrabatt",
    "discountLabel-integratiepremie": "Integrationsprämie",
    "discountLabel-nieuwbouwpremie": "Neubauprämie",
    "discountLabel-ncw": "Nettobarwertverteilung",
    "total-incl-discount": "Gesamt (inkl. Rabatte)",
    "discountLabel-korting": "Rabatte",
    "discountLabel-overig": "Andere",
    "discountLabel-nabetaling": "Zusätzliche Zahlung",
    "discountLabel-correctievoerprijs": "Futterpreiskorrektur",
    "discountLabel-vergoedingvolgensafspraak": "Vergütung nach Vereinbarung",
    "feed-profit-per-m2": "Futtergewinn pro m²"
  },
  "total": "Total",
  "days-short": "Tagen",
  "parent-stock-identifier": "Bestands-ID der Eltern",
  "import": "importieren",
  "slaughter-report": "Schlachtbericht",
  "link-slaughter-results-title": "Verknüpfung von Schlachtergebnissen",
  "link-slaughter-results-description": "Wählen Sie einen Stallbericht pro Schlachtung aus. Pro Schlachtbericht wird dann eine Entsorgungslinie erstellt.",
  "slaughter-date": "Schlachtdatum",
  "number-of-chickens": "Anzahl Küken",
  "departure-weight-kg": "Entladegewicht (kg)",
  "show-financial-data": "Finanzdaten anzeigen",
  "financial-results": "Finanzielle Ergebnisse",
  "link-to-barn": "Link zur Scheune",
  "imported-slaughter-report-label": "Geïmporteerd slachtrapport",
  "slaughter-weight-kg": "Schlachtgewicht in kg",
  "veterinary": "Veterinärmedizins",
  "employment": "Arbeit",
  "otherRevenue": "andere Erträge",
  "otherCosts": "andere Kosten",
  "discount-title": "Rabatte",
  "discount-label": "Rabattetikett",
  "discount-applicabilityType": "Gilt für",
  "discount-amount": "Betrag, exkl. MwSt",
  "discount-item": {
    "applicabilityType-arrivalcost": "Anreisekosten",
    "applicabilityType-feedcost": "Futterkosten",
    "applicabilityType-departurerevenue": "Entladungsertrag",
    "add-discount": "Rabatt hinzufügen",
    "labelType-ledenvoordeel": "Vorteile für Mitglieder",
    "labelType-ledenkorting": "Mitgliederrabatt",
    "labelType-integratiepremie": "Integrationsprämie",
    "labelType-nieuwbouwpremie": "Neubauprämie",
    "labelType-ncw": "Nettobarwertverteilung",
    "labelType-korting": "Rabatte",
    "labelType-overig": "Andere",
    "labelType-nabetaling": "Zusätzliche Zahlung",
    "labelType-correctievoerprijs": "Futterpreiskorrektur",
    "labelType-vergoedingvolgensafspraak": "Vergütung nach Vereinbarung"
  },
  "discount": {
    "no-discounts-title": "Es gibt noch keine Rabatte.",
    "no-discounts-description": "Fügen Sie einen Rabatt hinzu und dieser wird hier angezeigt."
  },
  "delete-item-discount": "Möchten Sie den Rabatt entfernen?",
  "farm-result": {
    "table-header": {
      "sensorActuator": "Sensor/Actuator Id",
      "barn": "Stall",
      "sensorActuatorName": "Name des Sensors/Aktors",
      "farmResultLocationId": "Standort-ID"
    },
    "select-barn-placeholder": "- Stall auswählen -"
  },
  "discountLabel-korting": "Rabatte",
  "discountLabel-overig": "Andere",
  "discountLabel-nabetaling": "Zusätzliche Zahlung",
  "discountLabel-correctievoerprijs": "Futterpreiskorrektur",
  "discountLabel-vergoedingvolgensafspraak": "Vergütung nach Vereinbarung",
  "delete-item-day-old-chick-used-in-balance": "Dieser Vorrat wird in der Bilanz verwendet. Wenn Sie diesen Vorrat entfernen, muss der Saldo neu berechnet werden. Möchten Sie das Angebot löschen?",
  "edit-day-old-chick_barn-used-in-balance": "Sie ändern einen Stall, der in der Bilanz verwendet wird. Wenn Sie diese Änderung vornehmen, muss der Saldo neu berechnet werden. Möchtest du fortfahren?",
  "cycle-description": "Beschreibung Durchgang",
  "confirm": "Bestätigen",
  "interval-type-Day": "Tag",
  "interval-type-Week": "Woche",
  "unitOfMeasure-setting": {
    "title": "Bezeichnung",
    "warning": "Beim Ändern der Maßeinheitseinstellungen kann es durch mathematische Rundungen zu geringfügigen Wertdifferenzen kommen.",
    "waterIntakeUnit": "Wassereinlasseinheit",
    "CumulativeLiter": "Insgesamt L",
    "MililiterPerBird": "Mililiter pro Tier",
    "feedIntakeUnit": "Futteraufnahmeeinheit",
    "CumulativeKilogram": "Insgesamt Kg",
    "GramPerBird": "Gramm pro Tier"
  },
  "error-amount-of-chicks-minimum": "Die Mindestanzahl an Küken beträgt:",
  "animal-group": {
    "animalGroupTitle": "Tiergruppe",
    "switchDay": "Umstellungstag",
    "addSwitchDay": "Schalttag hinzufügen",
    "phaseFrom": "Phase von",
    "phaseTo": "Phase zu",
    "date": "Datum",
    "medication": "Medikamente",
    "treatmentDateStart": "Anfang der Behandlung",
    "treatmentDateEnd": "Ende der Behandlung",
    "addMedication": "Medikamente hinzufügen",
    "diagnose": "Diagnostizieren",
    "vaccination": "Imfpung",
    "addVaccination": "Impfung hinzufügen",
    "vaccine": "Impfstoff",
    "poultryDisease": "Geflügelkrankheit",
    "vaccinationMethod": "Impfmethode",
    "validationDialogTitle": "Benötigte Information",
    "validationDialogMessage": "Fügen Sie die erforderlichen Informationen in die Tabellen ein",
    "veterinarianTitle": "Tierarzt",
    "quantity": "Menge",
    "unit": "Einheit",
    "quantityUnitDescriptions": {
      "kilogram": "Kilogramm",
      "gramsPerLitre": "Gramm pro Liter",
      "percentage": "Prozent",
      "gram": "Gramm",
      "noUnit": "Keine Einheit",
      "gramsPerKilogram": "Gramm pro Kilogramm",
      "milligram": "Milligramm",
      "milligramsPerKilogram": "Milligramm pro Kilogramm"
    }
  },
  "final-setup-setting": {
    "switch": "Endgültige Einrichtung",
    "chick-delivery-switch": "Kükenlieferungen",
    "feed-delivery-switch": "Futterlieferungen",
    "departure-switch": "Abfahrt",
    "discount-switch": "Rabatte",
    "title": "Endgültige Einrichtung",
    "default-settings-title": "Standardeinstellungen",
    "masterdata": {
      "title": "Stammdaten",
      "notes": "Anmerkungen",
      "payer": "Zahler",
      "payer-email": "E-Mail des Zahlers",
      "representative-agrifirm": "Repräsentatives <Tenant>",
      "separate-stable": "Separater Stall",
      "integration-premium": "Integrationsprämie",
      "discount-value": "Wert des Rabatts",
      "agrifirm-member": "<Tenant>-Mitglied"
    }
  },
  "invoice-date": "Rechnungsdatum",
  "invoice-number": "Rechnungsnummer",
  "vat-percentage": "Mehrwertsteuer-Prozentsatz",
  "vat": "MwSt (%)",
  "amount-including-vat": "Betrag inklusive Mehrwertsteuer (€)",
  "final-setup": {
    "chick-deliveries": "Kükenlieferungen",
    "empty-chick-deliveries-title": "Keine Kükenlieferungen",
    "empty-chick-deliveries-description": "Keine Kükenlieferungen",
    "feed-deliveries": "Futterlieferungen",
    "empty-feed-deliveries-title": "Keine Futterlieferungen",
    "empty-feed-deliveries-description": "Keine Futterlieferungen",
    "empty-departures-description": "Keine Abgänge",
    "departures": "Verkauf an Schlachthöfe",
    "empty-departures-title": "Keine Abgänge",
    "discounts": "Rabatte",
    "empty-discounts-title": "Keine Rabatte",
    "empty-discounts-description": "Keine Rabatte",
    "print-footer": "Alle von uns abgeschlossenen Verträge und von uns gelieferten Produkte und/oder Dienstleistungen unterliegen ausschließlich den Allgemeinen Lieferbedingungen der Agrifirm NWE BV. Diese werden Ihnen auf erste Anfrage kostenlos zugesandt und können auch eingesehen und gespeichert werden über: https://www .agrifirm.nl/globalassets/agrifirm-group/agrifirm-nl/leveringsvoorwaarden/general-terms--nl.pdf​",
    "print-description": "Beschreibung",
    "print-message-line-1": "Sehr geehrter Herr / Frau,",
    "print-message-line-2": "Wir senden Ihnen eine Übersicht der Rechnungen der vergangenen Runde.",
    "print-end-line-1": "Die obige Übersicht muss mit Ihrer Verwaltung übereinstimmen.",
    "print-end-line-2": "Mit freundlichen Grüße,",
    "print-to-receive": "Indem wir Dich empfangen",
    "print-total-feed": "Gesamtfutter, Spezifikation siehe Anhang",
    "print-invoice-number": "Rechnungsnr.",
    "print-amount-excluding-vat": "Betrag ohne Mehrwertsteuer",
    "print-vat-amount": "Mehrwertsteuerbetrag",
    "print-amount-including-vat": "Betrag inklusive Mehrwertsteuer",
    "print-product": "Produkt",
    "print-net-weight": "Netto (kg)",
    "include-in-calculations-label": "In Berechnungen einbeziehen",
    "print-to-pay": "Indem ich Dich bezahle",
    "print-payment-terms": "Wir bitten Sie, den oben genannten Betrag innerhalb von 14 Tagen unter Angabe Ihrer Kundennummer auf das Bankkonto NL.86.RABO.010.10.50.003 zu überweisen.",
    "print-subtotal": "Zwischensumme",
    "feed-delivery-end-date": "Enddatum des endgültigen Einrichtungszyklus",
    "additional-invoices": "Zusätzliche Rechnungen",
    "empty-additional-invoices-title": "Keine zusätzlichen Rechnungen",
    "empty-additional-invoices-description": "Keine zusätzlichen Rechnungen",
    "additional-invoices-add": "Rechnung hinzufügen",
    "additional-invoices-delete-confirm-title": "Zusätzliche Rechnung entfernen",
    "additional-invoices-delete-confirm-description": "Möchten Sie diese Rechnung wirklich entfernen?",
    "fixed-price": "Festpreisvereinbarung",
    "fixed-price-per-100": "Preis pro 100 kg",
    "fixed-price-correction": "Preiskorrektur wie vereinbart",
    "price-agreement": "Preisvereinbarung",
    "per-100-kg": "/ 100 kg exkl. MwSt.",
    "day-old-chick": "Eintagsküken",
    "print-footer-agravis": "Alle von uns abgeschlossenen Verträge und von uns gelieferten Produkte und/oder Dienstleistungen unterliegen ausschließlich den Allgemeinen Lieferbedingungen von Agravis. Diese werden Ihnen auf erste Anfrage kostenlos zugesandt.",
    "print-company-name": "Agrifirm NWE BV",
    "print-company-name-agravis": "Agravis",
    "print-company-email": "E-Mail: kengetallenadministratie@agrifirm.com",
    "print-company-email-agravis": "E-Mail: info@agravis.nl",
    "print-company-phone": "Telefon: 088 - 488 2976",
    "print-company-phone-agravis": ""
  },
  "amount-excluding-vat": "Betrag, exkl. MwSt (€)",
  "discount-description": "Beschreibung",
  "discount-showInFinalSetup": "Im Endgültige Einrichtung anzeigen",
  "label": "Etikett",
  "link-slaughter-invoices-description": "Wählen Sie die Rechnungen aus, die mit dem Zyklus verknüpft werden müssen. Für jede Rechnung wird bei der endgültigen Einrichtung eine Zeile erstellt.",
  "link-slaughter-invoices-title": "Schlachtrechnungen verknüpfen",
  "slaughter-invoice": "Schlachtrechnung",
  "vaccination-price": "Impfpreis pro Küken",
  "discount-price": "Impfpreis pro Küken",
  "diverse-price": "Unterschiedliche Kosten pro Küken",
  "total-price-including-vat": "Betrag, inkl. MwSt",
  "total-calculated-amount": "Gesamtmenge",
  "total-calculated-amount-including-vat": "Gesamtbetrag inklusive Mehrwertsteuer",
  "arrival-notification-cycle-overview": "Der Nettopreis pro Impfung und sonstige Posten pro Küken sind in der Finanzübersicht enthalten, wo auch die Gesamtsumme zu finden ist",
  "arrival-notification-final-setup": "Der Nettopreis pro Impfung und sonstige Posten pro Küken sind in der Finanzübersicht enthalten, wo auch die Gesamtsumme zu finden ist",
  "edit-day-old-chick": "Einstallung ändern",
  "edit-departure": "Ausstallung ändern",
  "of-delivery": "von Einstallung",
  "delivery-date": "Lieferdatum",
  "delivery-number": "Liefer-ID",
  "base-quantity": "Menge",
  "discount-setting": {
    "title": "Rabatte",
    "memberDiscountNL": "Mitgliederrabatt (€)",
    "memberBenefitNL": "Mitgliedervorteil (%)",
    "memberBenefitAbroad": "Mitgliedervorteil im Ausland (%)",
    "warning-title": "In acht nehmen!",
    "warning-message": "Diese Werte werden für alle Kunden und Standorte verwendet. Verändere sie nicht."
  },
  "sustainability": {
    "calculations": {
      "source": "Quelle",
      "value": "Wert",
      "unit": "Einheit",
      "description": "Sehen Sie frühere Berechnungen an oder berechnen Sie einen anderen Durchgang.",
      "new": "Neue Berechnung",
      "result": "Gespeichertes Ergebnis",
      "history": "Frühere Berechnungen",
      "last-updated": "Zuletzt aktualisiert",
      "history-description": "Wählen Sie eine Berechnung aus, um das Ergebnis anzuzeigen.",
      "calculation": "Berechnung",
      "view-result": "Ergebnis anzeigen",
      "empty": "Für diesen Durchgang sind noch keine Berechnungen gespeichert.",
      "select-cycle": "Wählen Sie einen Durchgang aus, um gespeicherte Berechnungen anzuzeigen.",
      "loading": "Berechnungen werden geladen…",
      "load-error": "Berechnungen konnten nicht geladen werden. Versuchen Sie es erneut.",
      "retry": "Erneut versuchen",
      "pending": "Diese Berechnung wird noch verarbeitet. Aktualisieren Sie das Ergebnis später.",
      "calculating": "Futter wird importiert und der CO₂-Fußabdruck berechnet…",
      "result-failed": "Diese Berechnung ist fehlgeschlagen. Prüfen Sie die Anforderungen im Berechnungsbereich und versuchen Sie es erneut. Wenden Sie sich bei weiteren Problemen an Ihren Berater.",
      "attempt-failed": "Der letzte Versuch ist fehlgeschlagen. Prüfen Sie die Anforderungen unten und versuchen Sie es erneut. Gespeicherte Ergebnisse bleiben verfügbar.",
      "status": {
        "complete": "Berechnet",
        "pending": "In Bearbeitung",
        "failed": "Fehlgeschlagen"
      }
    },
    "readiness": {
      "view-details": "Futterdaten anzeigen",
      "requirements-met": "Anforderungen erfüllt",
      "title": "Voraussetzungen",
      "checking": "Benötigte Daten werden geprüft…",
      "error": "Die benötigten Daten konnten nicht geprüft werden. Versuchen Sie es erneut.",
      "ready": "Benötigte Daten vollständig.",
      "blocked": "Ergänzen Sie die folgenden Angaben vor der Berechnung.",
      "complete": "Vollständig",
      "action-required": "Aktion erforderlich",
      "edit-arrivals": "Einstallungen bearbeiten",
      "edit-departures": "Ausstallungen bearbeiten",
      "edit-resources": "Energie pro Jahr bearbeiten",
      "edit-bedding": "Einstreu bearbeiten",
      "advisor": "Wenden Sie sich an Ihren Berater, um diese Daten zu korrigieren. Teilen Sie die oben genannten Produkt- und Lieferdaten mit.",
      "disclaimer": "Diese Prüfung kontrolliert die benötigten Daten. Sustell kann die Berechnung weiterhin ablehnen.",
      "recheck": "Erneut prüfen",
      "calculation-failed": "Sustell konnte diesen CO₂-Fußabdruck nicht berechnen. Prüfen Sie die Voraussetzungen und versuchen Sie es erneut. Bei weiteren Fehlern wenden Sie sich an Ihren Berater.",
      "requirements": {
        "cycle": "Einstallungen, Ausstallungen und gültige Daten",
        "farm-resources": "Energie für jedes benötigte Jahr",
        "bedding": "Einstreudaten",
        "feeds": "Nährwerte und Emissionen des Futters"
      },
      "arrival-weight": "Durchschnittliches Einstallgewicht pro Tier",
      "departure-weight": "Durchschnittliches Ausstallgewicht pro Tier",
      "issues": {
        "feeds-missing": "Erfassen Sie den Kraftfutterverbrauch in der Futterbilanz dieses Durchgangs.",
        "arrivals-missing": "Erfassen Sie die Kükeneinstallungen.",
        "departures-missing": "Erfassen Sie die Ausstallungen.",
        "cycle-dates-invalid": "Korrigieren Sie die Zyklus-, Einstallungs- und Ausstallungsdaten.",
        "arrival-data-invalid": "Geben Sie eine positive Tierzahl und ein Einstallgewicht in Gramm pro Tier ein.",
        "departure-data-invalid": "Geben Sie eine positive Tierzahl und ein Gesamtausstallgewicht in kg ein.",
        "departure-weight-below-arrival": "Das durchschnittliche Ausstallgewicht muss mindestens dem durchschnittlichen Einstallgewicht entsprechen. Prüfen Sie das Einstallgewicht in Gramm pro Tier, das Gesamtausstallgewicht in kg und die Tierzahlen.",
        "farm-resources-missing": "Erfassen Sie den Energieverbrauch für das Jahr",
        "cycle-dates-required": "Erfassen Sie gültige Einstallungen und Ausstallungen, damit die benötigten Jahre geprüft werden können.",
        "bedding-type-missing": "Wählen Sie eine Einstreuart.",
        "bedding-amount-missing": "Geben Sie die Einstreumenge ein.",
        "ship-to-missing": "Der Lieferort ist nicht mit dem Futterlieferanten verknüpft.",
        "delivery-missing": "Lieferdaten fehlen.",
        "delivery-line-missing": "Daten zum gelieferten Produkt fehlen.",
        "feed-data-invalid": "Benötigte Futterdaten fehlen oder sind ungültig.",
        "feed-settings-missing": "Die Einstellungen für den Futterimport sind unvollständig.",
        "farm-resources-not-calculated": "Speichern Sie die Energiedaten erneut, um den Verbrauch diesem Zyklus zuzuordnen."
      },
      "fields": {
        "Consumption": "Futterverbrauch (kg), größer als null",
        "Co2Total": "Gesamter CO₂-Fußabdruck",
        "Co2TotalMismatch": "Der CO₂-Gesamtwert stimmt nicht mit der Summe der biogenen, fossilen und Landnutzungsänderungsemissionen überein. Bitten Sie Ihren Berater, die Futterdaten zu korrigieren.",
        "Biogenic": "Biogene Emissionen",
        "FossilExcludingPeatEmissions": "Fossile Emissionen ohne Torf",
        "FossilPeatEmissions": "Torfemissionen",
        "LandUseChange": "Emissionen durch Landnutzungsänderungen",
        "DryMatterAmount": "Trockenmassegehalt",
        "RoughProtein": "Proteingehalt",
        "ProductIdentifier": "Produktnummer"
      },
      "edit-feeds": "Futterbilanz bearbeiten",
      "edit-cycle": "Zyklus bearbeiten"
    },
    "sustainability": "Nachhaltigkeit",
    "farm-resources": "Energie pro Jahr",
    "carbon-footprint": "Empreinte CO2",
    "add-farm-resources": "Hofressourcen hinzufügen",
    "confirm-delete-farm-resource": "Die Hofressource löschen?",
    "farm-resource-deleted": "Hofressource gelöscht",
    "farm-resource-saved": "Hofressource gespeichert",
    "year": "Jahr",
    "farm-settings-saved": "Hofeinstellungen gespeichert",
    "farm-settings-enable-co2-calculation": "CO2-Berechnungen für diesen Hof aktivieren",
    "resource": {
      "electricity": "Elektrizität (kWh)",
      "electricity-photovoltaic": "Elektrizität Sonne (kWh)",
      "electricity-wind": "Elektrizität Wind (kWh)",
      "natural-gas": "Erdgas (m³)",
      "diesel": "Diesel (L)",
      "gasoline": "Benzin (L)",
      "coal": "Kohle (KG)",
      "propane-lpg": "Propan / LPG (L)",
      "water": "Wasser (m³)",
      "cycle-start-date": "Startdatum",
      "cycle-end-date": "Enddatum",
      "status": "Status",
      "statuses": {
        "complete": "Geschlossen",
        "partial": "Unvollständig"
      },
      "water-error": "Wasser muss eine positive Zahl sein",
      "electricity-error": "Elektrizität muss eine positive Zahl sein",
      "electricity-photovoltaic-error": "Strom Sonne muss eine positive Zahl sein",
      "electricity-wind-error": "Strom Wind muss eine positive Zahl sein",
      "natural-gas-error": "Erdgas muss eine positive Zahl sein",
      "diesel-error": "Diesel muss eine positive Zahl sein",
      "gasoline-error": "Benzin muss eine positive Zahl sein",
      "propane-lpg-error": "Propan/LPG muss eine positive Zahl sein",
      "coal-error": "Kohle muss eine positive Zahl sein"
    },
    "farm-resources-title": "Energieverbrauch pro Jahr",
    "cycle-resources": "Energieverbrauch pro Runde",
    "value": "Wert Lebendgewicht (kg CO2eq / kg Körpergewicht)",
    "notification-title": "Wichtige Informationen über CO2-Berechnungen",
    "notification-description": "Die Berechnung des CO2-Fußabdrucks erfolgt mit der LCA-Software Sustell. Grundlage hierfür sind die CO2-Berechnungen des Futters gemäß der aktuellen Nevedi-Richtlinie. Für eine korrekte Berechnung müssen alle Daten vollständig eingegeben werden, wie zum Beispiel die <b>technischen Leistungen einer Herde inkl. Produktion, Abgang/Schlachtung und Energieverbrauch.</b>\nDie angezeigten Werte können sich aufgrund von Entwicklungen in der Klimawissenschaft und den daraus resultierenden Änderungen an den Berechnungssystemen sowie durch Änderungen von Gesetzen, Vorschriften und gegebenenfalls geltenden Standards ändern. Obwohl die hier dargestellten Informationen mit Sorgfalt zusammengestellt wurden, können daraus keine Rechte abgeleitet werden.",
    "action-text-close": "Ausblenden",
    "action-text-open": "Anzeige",
    "farm-resources-not-complete": "Die Zyklusressourcen sind nicht vollständig.",
    "bedding-type-required": "Die Art der Einstreu ist für den Zyklus erforderlich.",
    "bedding-amount-required": "Die Einstreumenge ist für den Zyklus erforderlich.",
    "start-calculation": "CO2-Berechnung starten",
    "refresh-carbon-footprint": "CO2-Fußabdruck aktualisieren",
    "carbon-footprint-title-error": "Fehler bei der Berechnung des CO2-Fußabdrucks",
    "carbon-footprint-title": "Berechnung des CO2-Fußabdrucks",
    "carbon-footprint-text": "Die Berechnung des CO2-Fußabdrucks wird gestartet. Bitte haben Sie etwas Geduld, während der Vorgang abgeschlossen wird (etwa 1 Minute).",
    "carbon-footprint-refresh-error-title": "CO2-Fußabdruck konnte nicht aktualisiert werden",
    "carbon-footprint-refresh-error-text": "Der CO2-Fußabdruck konnte nicht aktualisiert werden. Bitte versuchen Sie es in einem Moment erneut."
  },
  "bedding-type": "Einstreutyp",
  "bedding-types": {
    "NoBedding": "Keine Einstreu",
    "BarleyStraw": "Gerstenstroh",
    "MaizeStover": "Maisstroh",
    "OatStraw": "Haferstroh",
    "SawDust": "Sägemehl",
    "SunflowerHusk": "Sonnenblumenschale",
    "WheatStraw": "Weizenstroh",
    "Woodshavings": "Holzspäne"
  },
  "bedding-amount": "Einstreumenge",
  "bedding-amount-error": "Die Menge an Einstreu muss eine positive Zahl sein",
  "transport-distance": "Transport von der Brüterei",
  "transport-distance-error": "Der Transport vom Aufzuchtbetrieb muss eine Zahl zwischen 0 und 1000 sein",
  "time-in-free-range": "Zeit im Freiland",
  "time-in-free-range-error": "Die Zeit im Freiland muss eine Zahl zwischen 0 und 100 sein",
  "general-settings-error": "Beim Abrufen der Einstellungen für PoultryNEXT ist ein Fehler aufgetreten.",
  "csv-import": {
    "delivery-success": "Lieferungen wurden erfolgreich importiert.",
    "departure-success": "Abgänge wurden erfolgreich importiert.",
    "errors": {
      "amount-exceeds-remaining": "Zeile ${rowNumber}: Die Menge überschreitet die verbleibenden Küken für Stall '${barn}'. Die maximal erlaubte Menge ist ${maxAmount}.",
      "barn-not-found": "Zeile ${rowNumber}: Stall '${value}' wurde im ausgewählten Durchgang nicht gefunden.",
      "configured-slaughterhouses-could-not-be-loaded": "Konfigurierte Schlachthöfe konnten nicht geladen werden.",
      "cycle-could-not-be-loaded": "Durchgang '${cycleId}' konnte nicht geladen werden.",
      "cycle-invalid": "CSV-Abgänge sind für den ausgewählten Durchgang ungültig.",
      "cycle-not-found": "Durchgang '${cycleId}' wurde für den aktuellen Kunden/Standort nicht gefunden.",
      "date-before-first-arrival": "Zeile ${rowNumber}: Das Datum muss am oder nach dem ersten Ankunftsdatum liegen.",
      "date-in-future": "Zeile ${rowNumber}: Das Datum darf nicht in der Zukunft liegen.",
      "duplicate-column": "CSV enthält die doppelte Spalte '${column}'.",
      "file-empty": "CSV-Datei ist leer.",
      "file-required": "CSV-Datei ist erforderlich.",
      "file-too-large": "CSV-Datei ist zu groß. Die maximal erlaubte Größe ist ${maxSizeKb} KB.",
      "invalid-date": "Zeile ${rowNumber}: ${field} ist erforderlich und muss ein gültiges Datum sein.",
      "invalid-number": "Zeile ${rowNumber}: ${field} muss eine gültige Zahl sein.",
      "missing-required-columns": "CSV fehlt/fehlen erforderliche Spalte(n): ${columns}.",
      "no-data-rows": "CSV muss mindestens eine Datenzeile enthalten.",
      "required-field": "Zeile ${rowNumber}: ${field} ist erforderlich.",
      "required-positive-whole-number": "Zeile ${rowNumber}: ${field} ist erforderlich und muss eine positive ganze Zahl sein.",
      "required-valid-number": "Zeile ${rowNumber}: ${field} ist erforderlich und muss eine gültige Zahl sein.",
      "skip-import-invalid": "Zeile ${rowNumber}: Import überspringen muss leer sein oder einen der folgenden Werte enthalten: yes, no, true, false, 1, 0, x.",
      "slaughterhouse-not-found": "Zeile ${rowNumber}: Schlachthof '${value}' wurde nicht gefunden.",
      "too-many-rows": "CSV enthält zu viele Zeilen. Die maximal erlaubte Zeilenanzahl ist ${maxRows}.",
      "total-slaughterweight-higher-than-departure-weight": "Zeile ${rowNumber}: Das gesamte Schlachtgewicht darf nicht höher sein als das Abgangsgewicht.",
      "type-invalid": "Zeile ${rowNumber}: Typ ist erforderlich und muss Vollständig oder Teilweise sein.",
      "unterminated-quote": "CSV enthält einen Wert mit einem öffnenden Anführungszeichen ohne schließendes Anführungszeichen.",
      "unknown": "CSV-Import fehlgeschlagen.",
      "unsupported-file-type": "Es werden nur CSV-Dateien unterstützt."
    },
    "download-template": "Vorlage herunterladen",
    "invalid-file": "Wählen Sie eine gültige CSV-Datei aus.",
    "upload": "CSV hochladen"
  },
  "tenants": {
    "Agrifirm": "agrifirm",
    "Agravis": "agravis"
  }
}
